<template>
    <div class="placeholder-glow d-flex align-items-center justify-content-between step_skeleton" >
        <div class="placeholder skeleton"></div>
        <div class="placeholder skeleton"></div>
        <div class="placeholder  skeleton"></div>
    </div>
</template>


<style scoped>
.step_skeleton{
    height: 80px;
    margin-bottom: 2%;
}

@media(max-width: 767px){
    .step_skeleton{
        height: 62px;
        margin-bottom: 2%;
    }
}

.skeleton{
    height: 100%;
    width: 32%;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.3);
    mask-image: radial-gradient(white, black);
    cursor: wait;
    overflow: hidden;
}

</style>
